export const DEFAULT_VAULT_ICON = 'lock';
export const DEFAULT_OPEN_VAULT_ICON = 'users';

export const VAULT_ICON_OPTIONS: Array<{
  id: string;
  label: string;
  emoji: string;
}> = [
  { id: 'lock', label: 'Lock', emoji: '🔐' },
  { id: 'house', label: 'Home', emoji: '🏠' },
  { id: 'book', label: 'Book', emoji: '📚' },
  { id: 'briefcase', label: 'Briefcase', emoji: '💼' },
  { id: 'leaf', label: 'Leaf', emoji: '🍃' },
  { id: 'heart', label: 'Heart', emoji: '❤️' },
  { id: 'camera', label: 'Camera', emoji: '📷' },
  { id: 'users', label: 'People', emoji: '👥' },
  { id: 'rocket', label: 'Rocket', emoji: '🚀' },
  { id: 'folder', label: 'Folder', emoji: '📁' },
];

export function vaultIconEmoji(id: string | undefined) {
  return VAULT_ICON_OPTIONS.find((entry) => entry.id === id)?.emoji ?? '🔐';
}
